import { createContext } from 'react';

const ConversionParamsContext = createContext({
  sourceParam: '',
  targetParam: '',
});

export default ConversionParamsContext;
